module.exports = __webpack_public_path__ + "img/close_icon.2fb0dd55.svg";